// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__hp_2D","alert":"SettungsInbox_alert__ALqde"};